import {
  ColumnDefinition,
  OuiRecordDatasource as OuiDatasource,
  OuiDataTableComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, computed, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { css } from '@emotion/css';
import { DownloadButtonComponent } from '../../components/download-button/download-button.component';
import { PageComponent } from '../../components/page/page';
import { SelectComponent } from '../../components/select/select.component';
import { Warehouse } from '../../models/warehouse.models';
import { WarehouseService } from '../../services/warehouse/warehouse.service';
import { BasePageComponent } from '../base/base.component';
@Component({
  selector: 'app-warehouse-management',
  standalone: true,
  imports: [
    OuiDataTableComponent,
    OuiTextComponent,
    SelectComponent,
    ReactiveFormsModule,
    DownloadButtonComponent,
    PageComponent,
  ],
  templateUrl: './warehouse-management.component.html',
})
export class WarehouseManagementPage extends BasePageComponent {
  public warehouseService = inject(WarehouseService);

  tableHeaderClassName = css({
    display: 'flex !important' as 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  });

  tableHeaderLeftClassName = css({
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  });

  tableHeaderFilterClassName = css({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  });

  tableHeaderFilterGroupClassName = css({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  });

  warehousesDatasource?: OuiDatasource<Warehouse>;

  warehousesColumns: ColumnDefinition<Warehouse>[] = [
    {
      columnDef: 'code',
      header: 'Code',
    },
    {
      columnDef: 'name',
      header: 'Name',
    },
    {
      columnDef: 'dccCode',
      header: 'DCC',
    },
    {
      columnDef: 'entityCode',
      header: 'Entity',
    },
    {
      columnDef: 'wmsCode',
      header: 'WMS',
    },
  ];

  filterForm = new FormGroup({
    dcc: new FormControl<string>(''),
    wms: new FormControl<string>(''),
  });

  dccOptions = computed(() => [
    { label: '--Any--', value: '' },
    ...this.warehouseService.dccCodeOptions(),
  ]);

  selectedDcc = toSignal(this.filterForm.controls.dcc.valueChanges);

  wmsOptions = computed(() => [
    { label: '--Any--', value: '' },
    ...this.warehouseService.wmsCodeOptions(),
  ]);

  selectedWms = toSignal(this.filterForm.controls.wms.valueChanges);

  constructor() {
    super();

    effect(() => {
      const dccCode = this.selectedDcc();
      const wmsCode = this.selectedWms();

      let filter: (option: Warehouse) => boolean = () => true;

      if (wmsCode && dccCode) {
        filter = (option) =>
          option.dccCode === dccCode && option.wmsCode === wmsCode;
      } else if (wmsCode && !dccCode) {
        filter = (option) => option.wmsCode === wmsCode;
      } else if (!wmsCode && dccCode) {
        filter = (option) => option.dccCode === dccCode;
      }

      this.warehousesDatasource?.setFilter(filter);
    });

    effect(() => {
      this.warehousesDatasource = new OuiDatasource(
        this.warehouseService.warehouses.value(),
      );
    });
  }

  handleRowClick(warehouse: Warehouse) {
    this.router.navigate(['/locations/warehouses', warehouse.code]);
  }

  warehousesDownloadFileName = computed(() => {
    return [
      'ATB',
      this.selectedDcc(),
      this.selectedWms(),
      'Warehouses',
      new Date().toISOString().slice(0, 10),
    ]
      .join('_')
      .replace('__', '_');
  });
}
